module.exports = __webpack_public_path__ + "static/media/дубрава.b06b8013.png";